module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-bb_c8bdbe8.png";